export default __webpack_public_path__ + "static/media/yutu.2a91e7ec.png";